/* eslint-disable react/no-unused-prop-types */
import React from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import PropTypes from 'prop-types';

import { NEFIStepBranchSelection } from 'components/NEFIComponents/NEFISteps/NEFIStepBranchSelection/NEFIStepBranchSelection';
import { NEFIStepEmailInput } from 'components/NEFIComponents/NEFISteps/NEFIStepEmailInput/NEFIStepEmailInput';
import { NEFIStepForm } from 'components/NEFIComponents/NEFISteps/NEFIStepForm/NEFIStepForm';
import { NEFIStepFormUpload } from 'components/NEFIComponents/NEFISteps/NEFIStepFormUpload/NEFIStepFormUpload';
import { NEFIStepsContainer } from 'components/NEFIComponents/NEFIStepsContainer/NEFIStepsContainer';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';
import { SubTitle } from 'components/SubTitle/SubTitle';

import { FACHINTERESSENT_ACCESS_DENIED_MESSAGE, NE_ACTIVE_STEP } from 'global/constants';

import { parseAEMDatapolicyProps } from 'utils/AEMPropUtils';
import { isFachinteressentRegistrationBlockedTenant } from 'utils/fachinteressentAccess';
import { getTenantId } from 'utils/tenantUtil';

import './NEFIForm.sass';

export const NEFIForm = (props) => {
  const isEditor = Utils.isInEditor();
  const { gasAgreementLink, energyAgreementLink } = props;
  if (isEditor) {
    return <RenderAemComponent componentProps={props} name="NewEntryFachinteressentForm" />;
  }

  if (isFachinteressentRegistrationBlockedTenant(getTenantId())) {
    return (
      <SubTitle
        className="card-collection-my-data__sub-title-wrapper"
        text={FACHINTERESSENT_ACCESS_DENIED_MESSAGE}
      />
    );
  }

  return (
    <div className="nefi-form">
      <div className="nefi-form__container">
        <NEFIStepsContainer>
          <NEFIStepEmailInput key={NE_ACTIVE_STEP.EMAIL_INPUT} />
          <NEFIStepBranchSelection key={NE_ACTIVE_STEP.BRANCH_SELECTION} />
          <NEFIStepForm
            key={NE_ACTIVE_STEP.FORM}
            energyAgreementLink={energyAgreementLink}
            gasAgreementLink={gasAgreementLink}
          />
          <NEFIStepFormUpload
            key={NE_ACTIVE_STEP.FORM_UPLOAD}
            dataPolicyDocuments={parseAEMDatapolicyProps(props)}
          />
        </NEFIStepsContainer>
      </div>
    </div>
  );
};

NEFIForm.displayName = 'NEFIForm';

NEFIForm.propTypes = {
  expertQualificationCertificateGasLink: PropTypes.string,
  expertQualificationCertificateEnergyLink: PropTypes.string,
  installerContractMeterInstallationGasLink: PropTypes.string,
  installerContractMeterInstallationEnergyLink: PropTypes.string,
  installerContractSealing: PropTypes.string,
  installerContractLink: PropTypes.string,
  installerContractLinkEENGLink: PropTypes.string,
  installerContractLinkNNNGLink: PropTypes.string,
  installerContractLinkHANSGLink: PropTypes.string,
  selfDeclarationCompanyFacilityLink: PropTypes.string,
  selfDeclarationCompanyFacilityNNNGLink: PropTypes.string,
  selfDeclarationCompanyFacilityLinkMTNEnergy: PropTypes.string,
  selfDeclarationCompanyFacilityLinkMTNGas: PropTypes.string,
  gasAgreementLink: PropTypes.string,
  energyAgreementLink: PropTypes.string,
  datapolicyEDILink: PropTypes.string,
  datapolicyAVALink: PropTypes.string,
  datapolicySHNGLink: PropTypes.string,
  datapolicyBAGLink: PropTypes.string,
  datapolicyEENGLink: PropTypes.string,
  datapolicyHANSGLink: PropTypes.string,
  datapolicyNNNGLink: PropTypes.string,
  datapolicyEDILabel: PropTypes.string,
  datapolicyAVALabel: PropTypes.string,
  datapolicyBAGLabel: PropTypes.string,
  datapolicySHNGLabel: PropTypes.string,
  datapolicyEENGLabel: PropTypes.string,
  datapolicyHANSGLabel: PropTypes.string,
  datapolicyNNNGLabel: PropTypes.string,
};

NEFIForm.defaultProps = {
  expertQualificationCertificateGasLink: '',
  expertQualificationCertificateEnergyLink: '',
  installerContractMeterInstallationGasLink: '',
  installerContractMeterInstallationEnergyLink: '',
  installerContractSealing: '',
  installerContractLink: '',
  installerContractLinkEENGLink: '',
  installerContractLinkNNNGLink: '',
  installerContractLinkHANSGLink: '',
  selfDeclarationCompanyFacilityLink: '',
  selfDeclarationCompanyFacilityNNNGLink: '',
  selfDeclarationCompanyFacilityLinkMTNEnergy: '',
  selfDeclarationCompanyFacilityLinkMTNGas: '',
  gasAgreementLink: '',
  energyAgreementLink: '',
  datapolicyEDILink: '',
  datapolicyAVALink: '',
  datapolicySHNGLink: '',
  datapolicyBAGLink: '',
  datapolicyEENGLink: '',
  datapolicyHANSGLink: '',
  datapolicyNNNGLink: '',
  datapolicyEDILabel: '',
  datapolicyAVALabel: '',
  datapolicyBAGLabel: '',
  datapolicySHNGLabel: '',
  datapolicyEENGLabel: '',
  datapolicyHANSGLabel: '',
  datapolicyNNNGLabel: '',
};

MapTo(['e-fix/components/content/newentryfachinteressent'])(NEFIForm);
